<template>
  <div class="icon-container"
       :class="[size, color]">
    <!--    @import icon.svg-->
    <slot/>
  </div>
</template>

<script>
export default {
  name: "IconDefault",
  props: {
    icon: {
      type: String,
      default: 'arrow'
    },
    size: {
      type: String,
      default: 'default'
    },
    color: {
      type: String,
      default: 'default'
    }
  },
  data() {
    return {
      focusParam: false
    }
  }
}
</script>

<style scoped lang="scss">
  .icon-container {
    display: flex;
    line-height:0;
    width: 24px !important;
    height: 24px !important;
    transition: all .3s ease;

    @media(max-width: 769px) {
      transition: none;
    }
    &.small {
      width: 16px !important;
      height: 16px !important;
    }
    &.mini {
      width: 20px !important;
      height: 20px !important;

      &.cross {
        padding: 2px;
      }
    }

    &.big {
      width: 32px !important;
      height: 32px !important;
    }
    :deep(svg) {
      path {
        transition: all .3s ease;
      }
      rect {
        transition: all .3s ease;
      }

      circle {
        transition: all .3s ease;
      }
    }

    &.orange {
      :deep(svg) {
        path {
          stroke: var(--color-orange);
        }

        rect {
          stroke: var(--color-orange);
        }
        circle {
          stroke: var(--color-orange);
        }
      }
    }
    &.red {
      :deep(svg) {
        path {
          stroke: var(--color-red);
        }

        rect {
          stroke: var(--color-red);
        }
        circle {
          stroke: var(--color-red);
        }
      }
    }

    &.green {
      :deep(svg) {
        path {
          stroke: var(--color-green);
        }

        rect {
          stroke: var(--color-green);
        }
        circle {
          stroke: var(--color-green);
        }
      }
    }

    &.light{
      :deep(svg) {
        ellipse {
          stroke: var(--color-grey);

        }
        path {
          stroke: var(--color-grey);
        }

        rect {
          stroke: var(--color-grey);
        }
        circle {
          stroke: var(--color-grey);
        }
      }
    }
    &.dark-green {
      :deep(svg) {
        ellipse {
          stroke: var(--color-dark-green);

        }
        path {
          stroke: var(--color-dark-green);
        }

        rect {
          stroke: var(--color-dark-green);
        }
        circle {
          stroke: var(--color-dark-green);
        }
      }
    }
    &.dark-green-light {
      :deep(svg) {
        path {
          stroke: var(--color-dark-green);
          opacity: 0.6;
        }

        rect {
          stroke: var(--color-dark-green);
          opacity: 0.6;

        }
        circle {
          stroke: var(--color-dark-green);
          opacity: 0.6;
        }
      }
    }


    &.light-purple {
      :deep(svg) {
        path {
          stroke: var(--color-light-purple);
        }

        rect {
          stroke: var(--color-light-purple);
        }
        circle {
          stroke: var(--color-light-purple);
        }
      }

      &:hover {
        :deep(svg) {
          path {
            stroke: var(--color-black);
          }

          rect {
            stroke: var(--color-black);
          }
          circle {
            stroke: var(--color-black);
          }
        }
      }
    }
    &.purple {
      :deep(svg) {
        path {
          stroke: var(--color-purple);
        }

        rect {
          stroke: var(--color-purple);
        }
        circle {
          stroke: var(--color-purple);
        }
      }
    }
    &.white {
      :deep(svg) {
        path {
          stroke: var(--color-white);
        }

        rect {
          stroke: var(--color-white);
        }
        circle {
          stroke: var(--color-white);
        }
      }
    }

  }

</style>